import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { isEmpty, sortBy } from 'lodash';

import { TerminologyVersionApi } from '../../../../../../api';
import ItemGroupTemplatesApi from '../../../../../../api/protocol/ItemGroupTemplatesApi';
import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import modalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../common/general/ButtonGroup';

export default function SaveItemGroupAsTemplateNameChangeModal({
  modalBox,
  elementName,
  domainCode,
  itemGroupType,
  onSaveData
}) {
  const [name, setName] = useState(elementName);
  const [lastTerminologyVersionNumber, setLastTerminologyVersionNumber] = useState(null);

  useEffect(() => {
    TerminologyVersionApi.getAllTerminologyVersionGroups().then(({ data }) => {
      setLastTerminologyVersionNumber(sortBy(data, 'number', 'desc').reverse()[0].number);
    });
  }, []);

  const onSave = () => {
    ItemGroupTemplatesApi.getItemGroupTemplateIdByNameDomainAndType(name.trim(), domainCode, itemGroupType).then(
      ({ data }) => {
        const saveAsTemplateData = {
          templateId: data && !isEmpty(data.trim()) ? data : null,
          name: name,
          lastTerminologyVersionNumber: lastTerminologyVersionNumber
        };

        if (!data || isEmpty(data.trim())) {
          onSaveData(null, saveAsTemplateData);
          modalBox.close();
        } else {
          modalBoxes
            .confirm({
              content: 'Template already exists, do you want to update?',
              confirmButton: 'Yes',
              cancelButton: 'No'
            })
            .then(
              () => {
                onSaveData(null, saveAsTemplateData);
                modalBox.close();
              },
              () => {}
            );
        }
      }
    );
  };

  return (
    <>
      <ModalBoxes.Body>
        <TextField
          value={name}
          onChange={e => setName(e.target.value)}
          sx={{ width: '100%', '.MuiFormHelperText-root': { textAlign: 'end' } }}
          variant="outlined"
        />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="low" onClick={modalBox.close}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={!name || name.trim() === ''}>
            Save
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}

SaveItemGroupAsTemplateNameChangeModal.className = 'save-as-template-name-change-modal';
SaveItemGroupAsTemplateNameChangeModal.size = 'w650';
